import { IconButton } from "Components/Button";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ICONS } from "Utils/icons";


function CompareModalLegend () {
    return (
        <div className="table-legend d-flex flex-column flex-md-row flex-wrap  mb-40px ">
            <div className="legend-item d-flex flex-row gap-8px">
                <div className="d-flex align-self-center">
                    <svg width="20" height="20">
                        <circle cx="10" cy="10" r="9" fill="#F7EFD2" stroke="#9E3900" stroke-width="1"/>
                    </svg>
                </div>
                <div className="legend-text">Value differs</div>
                <OverlayTrigger
                    overlay={
                        <Tooltip id="psoppcOnlyDesc" className="bodyS regular public-tooltip-light text-start">
                            This field has a different value in the selected version vs this version. Review carefully before submitting.
                        </Tooltip>
                    }
                >
                    <IconButton className="tooltip-btn-trigger" hiddenText="Value Differs description" variant="comp-plain" icon={ICONS.repoInfoTooltipTrigger}></IconButton>
                </OverlayTrigger>
            </div>
            <div className="legend-item d-flex flex-row gap-8px">
                <div className="d-flex align-self-center">
                    <svg width="20" height="20" >
                        <circle cx="10" cy="10" r="9" fill="white" stroke="#686E7A" stroke-width="1"/>
                    </svg>
                </div>
                <div className="legend-text">Identical</div>
                <OverlayTrigger
                    overlay={
                        <Tooltip id="psoppcOnlyDesc" className="bodyS regular public-tooltip-light text-start">
                            This field is the same across all versions being compared.
                        </Tooltip>
                    }
                >
                    <IconButton className="tooltip-btn-trigger" hiddenText="Identical description" variant="comp-plain" icon={ICONS.repoInfoTooltipTrigger}></IconButton>
                </OverlayTrigger>
            </div>
            <div className="legend-item d-flex flex-row gap-8px">
                <div className="d-flex align-self-center">
                    <svg width="20" height="20">
                        <circle cx="10" cy="10" r="9" fill="#E0E0E0" stroke="#686E7A" stroke-width="1" stroke-dasharray="2 2"/>
                    </svg>
                </div>
                <div className="legend-text">No equivalent</div>
                <OverlayTrigger
                    overlay={
                        <Tooltip id="psoppcOnlyDesc" className="bodyS regular public-tooltip-light text-start">
                            This data element does not exist in this version. It cannot be mapped or compared.
                        </Tooltip>
                    }
                >
                    <IconButton className="tooltip-btn-trigger" hiddenText="No Equivalent description" variant="comp-plain" icon={ICONS.repoInfoTooltipTrigger}></IconButton>
                </OverlayTrigger>
            </div>
        </div>
    );
}

export default CompareModalLegend;
